/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	/*globals BMap*/
	// import 'babel-polyfill';
	
	var locationDropdowns = $('#locationDropdowns'),
	    mapContainer = $('#mapContainer'),
	    items = locationDropdowns.find('.item a');
	
	//百度地图API功能
	function loadJScript() {
	  var script = document.createElement("script");
	  script.type = "text/javascript";
	  script.src = "http://api.map.baidu.com/api?v=1.4&callback=initMap";
	  document.body.appendChild(script);
	}
	window.initMap = function () {
	  //地图初始化
	  var map = new BMap.Map("mapContainer");
	  // 坐标获取：https://api.map.baidu.com/lbsapi/getpoint/index.html
	  var points = {
	    shenzhen: new BMap.Point(113.963836, 22.543481),
	    guangzhou: new BMap.Point(113.300382, 23.142501),
	    xiamen: new BMap.Point(118.202421, 24.494508),
	    fuzhou: new BMap.Point(119.276764, 26.118794)
	  };
	  map.enableScrollWheelZoom(true);
	  makMarker(map, points.shenzhen);
	  map.centerAndZoom(points.shenzhen, 18);
	  locationDropdowns.on('click.map', '.item', function (e) {
	    var value = $(e.target).data('value'),
	        point = points[value];
	    makMarker(map, point);
	    map && map.panTo(point); // jshint ignore:line
	    items.removeClass('active');
	    $(e.target).addClass('active');
	    if (value == "xiamen") {
	      $("#dingwei").text("厦门");
	    } else if (value == "guangzhou") {
	      $("#dingwei").text("广州");
	    } else if (value == "fuzhou") {
	      $("#dingwei").text("福州");
	    } else {
	      $("#dingwei").text("深圳");
	    }
	  });
	
	  function makMarker(map, point) {
	    if (map) {
	      var marker = new BMap.Marker(point); // 创建标注
	      map.addOverlay(marker);
	    }
	  }
	};
	
	window.onload = loadJScript; //异步加载地图

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// contact.js